<div *ngIf="showNoAgenyError">
  <div class="row mb-2">
    <div class="col pl-0">
      <div widget class="card border-0 box-shadow">
        <div class="card-body  widget-body pt-2">
          <div class="text-center text-danger">
            <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
              details</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Filter  -->
<div *ngIf="!showNoAgenyError">
  <div class="mb-2 mt-2">
    <h4  class="mb-2 py-1 font-header-1"> Purchase Request</h4>
  </div>
  <div class="card ps-0">
    <div class="card-body ">
     

      <div class="row mt-3">
        <div class="col-lg-2" *ngIf="(purchaseEmit.clientToPurchase  && fp.clientpurchasecreate) || global.OnboardingLoginType =='onboardLogin'">
          <button type="button" class="btn_m mb-2" data-bs-toggle="modal" data-bs-target="#PurchaseModal"
          (click)="clickaddpurchase()"
          
          [disabled]="global.viewTabs">
          New Purchase Request
        </button>
        </div>

        <div class="col-lg-4">
          <div class="row">
            <div class="col-lg-5">
              <label class="ms-5">Purchase Status</label>
            </div>
           
            <div class="col-lg-7">
              <ng-select [(ngModel)]="purchaselistBo.requestStatusLid" [items]="PurchaseStatusList" bindLabel="lovName"
                bindValue="id" [disabled]="global.viewTabs">
              </ng-select>
             
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="row">
            <div class="col-lg-5">
              <label class="ms-5">Purchase Type</label>
            </div>
            <div class="col-lg-7">
              <ng-select [(ngModel)]="purchaselistBo.purchaseTypeLid" [items]="purchaseTypeList" bindLabel="lovName"
                bindValue="id" [disabled]="global.viewTabs">
              </ng-select>
            </div>
          </div>
          
        </div>
        <div class="col-lg-4">
          <div class="row">
            <div class="col-lg-5">
              <label  class="ms-5"
                *ngIf="global.OnboardingLoginType !='onboardLogin' && !purchaseEmit.clientToPurchase">Client Name</label>
            </div>
            <div class="col-lg-7">
              <ng-select [(ngModel)]="purchaselistBo.clientId" bindLabel="Value" bindValue="Key" [items]="clientList"
                *ngIf="global.OnboardingLoginType !='onboardLogin' && !purchaseEmit.clientToPurchase">
              </ng-select>
            </div>
            
          </div>
           
          </div>
        </div>
        <div class="row mt-4">
          <div class="text-end">
            <div >
              <button type="button" class="btn btn-sm me-3" (click)="exportCsv()">
                <i class="fa fa-file-excel-o "></i>Export</button>
            <button type="button " class="btn btn-sm me-3" (click)="filterApply()" [disabled]="global.viewTabs">Apply</button>
         
         
            <button type="button " class="btn btn-sm" (click)="Refresh()" [disabled]="global.viewTabs">Refresh</button>
          </div>
        </div>

       
      
      </div>
     
    </div>
  </div>
</div>

<div class="mt-3" *ngIf="!showNoAgenyError">
  <div class="card ps-0">
    <div class="card-body">
      <div>
        <ejs-grid #grid [dataSource]='gridPurchase |async' [allowPaging]='true' [allowResizing]='true'
          [pageSettings]='initialPage' [filterSettings]='filterSettings' [allowFiltering]='true'
          [showColumnChooser]='true' [allowSorting]='true' (dataStateChange)='dataStateChange($event)'
          (actionBegin)="onActionComplete($event)">
          <e-columns>
            <e-column maxWidth=140 headerText="Actions" [showInColumnChooser]='false'>
              <ng-template #template let-data>
                <button class="btn btn-edit-table" data-bs-toggle="modal" data-bs-target="#PurchaseModal"
                  [disabled]="global.viewTabs" (click)="clickEditview(data);"><i class="fa fa-eye"></i></button>&nbsp;
                <button class="btn btn-edit-table" title="Approve" data-bs-toggle="modal"
                  data-bs-target="#AcceptModalOpen" (click)="clickEditview(data)"
                  [disabled]="data.requestStatusName != 'PENDING'"
                  *ngIf="global.OnboardingLoginType !='onboardLogin' && !purchaseEmit.clientToPurchase && fp.purchasereqapprove"><i
                    class="fa fa-check"></i></button>&nbsp;
                <button class="btn btn-edit-table" title="Reject" data-bs-toggle="modal"
                  data-bs-target="#RejectModalOpen" (click)="clickEditview(data)"
                  [disabled]="data.requestStatusName != 'PENDING'"
                  *ngIf="global.OnboardingLoginType !='onboardLogin' && !purchaseEmit.clientToPurchase && fp.purchasereqreject "><i
                    class="fa fa-times"></i></button>
              </ng-template>
            </e-column>
            <e-column minWidth=100 headerText="Client Name" field="clientName" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column minWidth=100 headerText="Request Date" field="requestDate" [format]="formatDateOptions"
              type="datetime">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>

            <e-column minWidth=100 headerText="Service Code" field="serviceName" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column minWidth=100 headerText="Item" field="item" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>

            <e-column minWidth=100 headerText="Item Description" field="description" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column minWidth=100 headerText="Quantity" field="quantity" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column minWidth=100 headerText="Rate" field="rate" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>

            <e-column minWidth=100 headerText="Billing Amount" field="totalAmount" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column minWidth=100 headerText="Type Of Purchase" field="purchaseTypeName" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column minWidth=100 headerText="Status" field="requestStatusName" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column minWidth=100 headerText="Status Modified Date" field="statusDate"
              [format]="formatDateOptions" type="datetime">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column minWidth=100 headerText="Insurance Number" field="insuranceNumber" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>

            <e-column width="50" [showInColumnChooser]='false'>
              <ng-template #headerTemplate let-data>
                <div>
                  <span id='show' (click)='showLocationColumns()'><i class="fa fa-cog fa-lg" aria-hidden="true">
                    </i></span>
                </div>
              </ng-template>
            </e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </div>
  </div>
</div>


<!-- Modal purchase save-->
<span id="PurchaseModalopen" data-bs-toggle="modal" data-bs-target="#PurchaseModal"></span>
<div class="modal fade" id="PurchaseModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="PurchaseModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" id="smallModal">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="PurchaseModalLabel"> Purchase Request</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="clickClose()"
          aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="d-flex">
        <div class="col-12" id="fisrtcol">
          <div class="row mt-2" *ngIf="global.OnboardingLoginType !='onboardLogin'">
            <div class="col-lg-4">
              <label>Client<sup class="super-script">*</sup></label>
            </div>
            <div class="col-lg-7">
              <input [(ngModel)]="purchaseClientName" class="form-control" disabled>

            </div>

          </div>
          <div class="row mt-2">
            <div class="col-lg-4">
              <label>Request Date<sup class="super-script">*</sup></label>
            </div>
            <div class="col-lg-7" *ngIf="!isview">
              <my-date-picker [options]="myDatePickerOptions" [selDate]="purchaseBO.requestDate"
                placeholder="mm/dd/yyyy" (inputFieldChanged)="newdates($event,'inputchange','date')"
                (dateChanged)="newdates($event,'datechanged','date');getAuthList();clearInputFeild()">
              </my-date-picker>
            </div>
            <div class="col-lg-7" *ngIf="isview">
              <input type="text" class="form-control" [(ngModel)]="purchaseBO.requestDate" disabled>

            </div>
          </div>

          <div class="row mt-2" *ngIf="!isview">
            <div class="col-lg-4">
              <label>Payer</label>
            </div>
            <div class="col-lg-7">
              <input type="text" class="form-control" [(ngModel)]="payer" disabled>

            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-4">
              <label>Service Code<sup class="super-script">*</sup></label>
            </div>
            <div class="col-lg-7">
              <input type="text" class="form-control" [(ngModel)]="serviceName" disabled>

            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-4">
              <label>Item</label>
            </div>
            <div class="col-lg-7">
              <input type="text" class="form-control" [(ngModel)]="purchaseBO.item" [disabled]="isview">

            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-4">
              <label>Item Description</label>
            </div>
            <div class="col-lg-7">
              <input type="text" class="form-control" [(ngModel)]="purchaseBO.description" [disabled]="isview">

            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-4">
              <label>Quantity<sup class="super-script">*</sup></label>
            </div>
            <div class="col-lg-7">
              <input type="number" min="0" class="form-control" [(ngModel)]="purchaseBO.quantity" (change)="getTotal()"
                [disabled]="isview">
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-4">
              <label>Rate<sup class="super-script">*</sup></label>
            </div>
            <div class="col-lg-7">
              <input type="number" min="0" class="form-control" [(ngModel)]="purchaseBO.rate" (change)="getTotal()"
                [disabled]="isview">
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-4">
              <label>Total Amount<sup class="super-script">*</sup></label>
            </div>
            <div class="col-lg-7">
              <input type="number" min="0" class="form-control" [(ngModel)]="purchaseBO.totalAmount" disabled>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-4">
              <label>Type of Purchase<sup class="super-script">*</sup></label>
            </div>
            <div class="col-lg-7">
              <ng-select [(ngModel)]="purchaseBO.purchaseTypeLid" [items]="purchaseTypeList" bindLabel="lovName"
                bindValue="id" (ngModelChange)="purchaseTypeFilter(purchaseBO.purchaseTypeLid)" [disabled]="isview">
              </ng-select>
            </div>
          </div>
          <div class="row mt-2" *ngIf="purchaseType=='Vendor Payment'">
            <div class="col-lg-4">
              <label>Vendor<sup class="super-script">*</sup></label>
            </div>
            <div class="col-lg-4">
              <ng-select [(ngModel)]="purchaseBO.vendorId" [items]="vendorList" bindValue="id" bindLabel="name"
                [disabled]="isview">
              </ng-select>
            </div>
            <div class="col-lg-2">
              <button type="button" class="btn btn-sm text-end " data-bs-toggle="modal" data-bs-target="#casemodalopen"
                (click)="CaseCreateupdate()"
                *ngIf="purchaseEmit.clientToPurchase || global.OnboardingLoginType =='onboardLogin'"
                [disabled]="isview">
                Add Vendor </button>

            </div>
          </div>

          <div class="row mt-2 mb-5" *ngIf="purchaseType=='Client Reimbursement'">
            <div class="col-lg-4">
              <label>Receipt<sup class="super-script">*</sup></label>
            </div>
            <div class="col-lg-5">
              <input type="file" class="form-control" [(ngModel)]="fileUpload"
                (change)="onDOCFileChanged($event.target.files)" *ngIf="!isview">
              <input type="text" class="form-control" [(ngModel)]="fileUpload" *ngIf="isview" [disabled]="isview">
            </div>
            <div class="col-lg-1">
              <button type="button" class="btn btn-sm"  [disabled]="!isview"  (click)="downloadFile()"> <i
                  class="fa fa-download fs-5 mt-1"></i></button>

            </div>

          </div>
        </div>
        
        <div class="col-6 p-0">
          <div class="mt-2" *ngIf="AuthList !=null && AuthList!=undefined && !isview && AuthList.length !=0">
            <ejs-grid [dataSource]='AuthList' [rowHeight]='40' [pageSettings]='initialPage' [allowPaging]='true'
              (rowSelected)='rowSelected($event)' [allowResizing]='true'>
              <e-columns>
                <e-column field="startDate" headerText="Start Date" minWidth=120 [format]='formatDateOptions'
                  type="datetime">
                  <ng-template #filterTemplate let-row>
                  </ng-template>
                </e-column>
                <e-column field="endDate" headerText="End Date" minWidth=120 [format]='formatDateOptions'
                  type="datetime">
                  <ng-template #filterTemplate let-row>
                  </ng-template>
                </e-column>
                <e-column field="payerName" headerText=" Payer Name" minWidth=120>
                  <ng-template #filterTemplate let-row>
                  </ng-template>
                </e-column>
                <e-column field="serviceName" headerText="service Name" minWidth=120>
                  <ng-template #filterTemplate let-row>
                  </ng-template>
                </e-column>

                <e-column field="authNote" headerText="AuthNote" minWidth=120>
                  <ng-template #filterTemplate let-row>
                  </ng-template>
              </e-column>

                <e-column field="remainingAmount" headerText="Remaining Amount" minWidth=120>
                  <ng-template #filterTemplate let-row>
                  </ng-template>
                </e-column>
                <e-column field="insuranceNumber" headerText="InsuranceNumber" minWidth=120>
                    <ng-template #filterTemplate let-row>
                    </ng-template>
                </e-column>
              
              </e-columns>
            </ejs-grid>
          </div>
        </div>
      </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm" (click)="savePurchase()" *ngIf="!isview" [disabled]=" 
        purchaseBO.quantity==null||purchaseBO.quantity==undefined||purchaseBO.rate ==undefined|| purchaseBO.rate ==null || purchaseBO.totalAmount==null || purchaseBO.totalAmount==undefined ||purchaseBO.purchaseTypeLid==null || purchaseBO.purchaseTypeLid==undefined|| purchaseBO.purchaseTypeLid==''|| (purchaseType=='Vendor Payment'&&(purchaseBO.vendorId==null|| purchaseBO.vendorId== undefined || purchaseBO.vendorId==''))|| 
        (purchaseType=='Client Reimbursement'&&(fileUpload==null|| fileUpload== undefined || fileUpload==''))
       ">Save &
          Submit</button>
        <button type="button" class="btn btn-sm" data-bs-dismiss="modal" (click)="clickClose()">Close</button>
      </div>
    </div>

  </div>
</div>


<!--  purchase Accept Modal-->
<span id="AcceptModal" data-bs-toggle="modal" data-bs-target="#AcceptModalOpen"></span>
<div class="modal fade modalbackgrod" id="AcceptModalOpen" data-bs-backdrop="false">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">
          <span>Purchase Reqest</span>
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">

        <label class="mx-auto" style="font-size: 12px;">
          Do you want to Accept this Reqest</label>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn  btn-sm" (click)="AcceptRequest()">Accept</button>
        <button type="button" class="btn  btn-sm" data-bs-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>
<!--  purchase Reject Modal-->
<span id="RejectModal" data-bs-toggle="modal" data-bs-target="#RejectModalOpen"></span>
<div class="modal fade modalbackgrod" id="RejectModalOpen" data-bs-backdrop="false">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">
          <span>Purchase Reqest </span>
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">

        <label class="mx-auto" style="font-size: 12px;">
          Do you want to Reject this Reqest</label>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn  btn-sm" (click)="RejectRequest()">Reject</button>
        <button type="button" class="btn  btn-sm" data-bs-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>





</div>


<!-- Insufficient balance error modal -->
<span id="Authmodal" data-bs-toggle="modal" data-bs-target="#AuthModal"></span>
<div class="modal fade modalbackgrod" id="AuthModal" data-bs-backdrop="false">
  <div class="modal-dialog ">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">
          <span>Insufficient Balance</span>
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">
        <label class="mx-auto mt-3" style="font-size: 12px; color: red;"><i
            class="fa fa-info-circle fa-lg"></i>&nbsp;{{acceptError}}
        </label>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn  btn-sm" (click)="saveAccept()">Yes</button>
        <button type="button" class="btn  btn-sm" data-bs-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>


<!-- vendor save modal -->

<span id="opencasemanModal1" data-bs-target="#casemodalopen" data-bs-toggle="modal"></span>
<div class="modal fade modalbackgrod" id="casemodalopen" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="false">
  <div class="modal-dialog modal-lg" role="document" modal-xl>
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Create Vendor </h5>

        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">

        <div class="row">
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-5">
                <label>Status<sup class="super-script">*</sup>
                </label>
              </div>
              <div class="col-lg-7">
                <ng-select class="w-100" [items]="statuslist" [searchable]="true" [clearable]="true"
                  [(ngModel)]="vendor.statusLid" bindLabel="lovName" bindValue="id">
                </ng-select>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-5">
                <label>Vendor Name<sup class="super-script">*</sup></label>
              </div>
              <div class="col-lg-7">
                <input type="text" class="form-control" [(ngModel)]="vendor.name">
              </div>
            </div>

          </div>

        </div>


        <div class="row mt-1">
          <div class="col-lg-6 ">
            <div class="row">
              <div class="col-lg-5">
                <label>companyName<sup class="super-script">*</sup></label>
              </div>
              <div class="col-lg-7">
                <input type="text" class="form-control" [(ngModel)]="vendor.companyName">
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-5">
                <label>Email<sup class="super-script">*</sup></label>
              </div>
              <div class="col-lg-7">
                <input type="text" class="form-control" [(ngModel)]="vendor.email">
              </div>
            </div>
          </div>

        </div>

        <div class="row mt-1">

          <div class="col-lg-6">
            <div class="row" [formGroup]="form">
              <div class="col-lg-5">
                <label>Phone</label>
              </div>
              <div class="col-lg-7">
                <input type="text" [(ngModel)]="vendor.phone" formControlName="phone" minlength="14" maxlength="14"
                  class="form-control" (ngModelChange)="PhoneFormat('phone')" (keypress)="keyPress($event)">
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row ">
              <div class="col-lg-5">
                <label>State</label>
              </div>
              <div class="col-lg-7">
                <ng-select [(ngModel)]="vendor.state" [items]="stateList" class="width25" [searchable]="true"
                  [clearable]="true" bindLabel="name" bindValue="abbreviation">
                </ng-select>
              </div>
            </div>
          </div>
        </div>


        <div class="row mt-1">

          <div class="col-lg-6">
            <div class="row ">
              <div class="col-lg-5">
                <label>Street</label>
              </div>
              <div class="col-lg-7 col-md-7">
                <input type="text" [(ngModel)]="vendor.street" class="form-control">
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row ">
              <div class="col-lg-5">
                <label>City</label>
              </div>
              <div class="col-lg-7">
                <input type="text" [(ngModel)]="vendor.city" class="form-control">
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-1" [formGroup]="form">
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-5">
                <label>ZipCode</label>
              </div>
              <div class="col-lg-7">
                <input type="text" class="form-control" formControlName="zipCode" minlength="5"
                  (keypress)="numberOnly($event)" maxlength="11" [(ngModel)]="vendor.zipCode">
                <div class="error" *ngIf="form.controls['zipCode'].touched && form.controls['zipCode'].invalid">
                  Enter Valid five digit number</div>

              </div>
            </div>
          </div>
        </div>

        <div class="row mt-1">
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-5">
                <label>TaxId</label>
              </div>
              <div class="col-lg-7">
                <input type="text" class="form-control" [(ngModel)]="vendor.taxId" (keypress)="keyPress($event)">

              </div>
            </div>
          </div>
        </div>




      </div>
      <div class="modal-footer">
        <button class="btn blue-btn btn-sm" (click)="SaveVendor()" [disabled]="(vendor.name=='' || vendor.name==undefined ||vendor.companyName=='' 
               || vendor.companyName==undefined || vendor.statusLid=='' || vendor.statusLid==undefined || vendor.email=='' ||
               vendor.email==undefined)"> Save & Close </button>

        <button type="button" class="btn btn-sm" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>



  
   

